import Vue from 'vue'
import VueRouter from 'vue-router'

import NotFound from 'src/views/NotFoundPage.vue'
import NotAutorizate from 'src/views/NotAutorizatePage.vue'
import DashboardLayoutMod from 'src/views/Layout/DashboardLayout.vue'
import LogoutPage from 'src/views/Logout.vue'
import { is_auth, login, logout, oauth2, home} from './../middleware/auth'
import Callback from 'src/views/Callback'
import ListarEgresos from'@/views/EstadoEgreso/EstadoEgreso.vue'
import ListarUsuarios from'@/views/Usuarios/ListarUsuarios.vue'
import UsuarioForm from '../views/Usuarios/UsuarioForm.vue'
import CargarEgreso from '@/views/cargaEgreso/Egreso'
import CargarEgresoExcel from '@/views/cargaEgreso/CargaEgresosExcel.vue'
import Home from '@/views/Home.vue'
import ListarMultas from'@/views/EstadoMulta/EstadoMulta.vue'
import CargarMulta from '@/views/cargaMulta/Multa'
import CargarMultaExcel from '@/views/cargaMulta/CargaMultasExcel.vue'
import PagoVocales from'@/views/EstadoPagoVocales/EstadoPagoVocales.vue'
import CargaPagoVocales from'@/views/cargaPagoVocales/CargaPagoVocalesCSV.vue'
import CargaPagoVocal from'@/views/cargaPagoVocales/pagoVocal.vue'
import envioCorreos from "@/views/envioCorreos/envioCorreos.vue";


Vue.use(VueRouter);


const routes = [

  { path: '/oauth2', component: Callback },
  { path: '/login', beforeEnter: login},
  { path: '/logout', beforeEnter: logout, component: LogoutPage },
  { path: '/auth/logout', beforeEnter: logout, component: LogoutPage },
  { path: '/auth/login', beforeEnter: logout, component: LogoutPage },
  { path: '/', beforeEnter: home},
  {
    path: '/admin',
    beforeEnter: is_auth,
    component: DashboardLayoutMod,
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'home',
        component: Home
    },
    {
      path: 'usuarios',
      name: 'usuarios',
      component: ListarUsuarios
    },
    {
      path: '/usuarios/crearusuario',
      name: 'crearUsuario',
      // beforeEnter: multiple([is_auth, solicitud_success]),
      component: UsuarioForm
    },
    {
      path: '/usuarios/editarusuario/:id',
      name: 'editarusuario',
      props: true,
      // beforeEnter: multiple([is_auth, solicitud_success]),
      component: UsuarioForm
    },
    {
      path: '/egreso/lista',
      name: 'egresos',
      component: ListarEgresos
    },
    {
      path: '/egreso/carga/formulario',
      name: 'crearEgreso',
      component: CargarEgreso
    },
    {
      path: '/egreso/carga/excel',
      name: 'crearEgresoExcel',
      component: CargarEgresoExcel
    },
    {
      path: '/multa/lista',
      name: 'multas',
      component: ListarMultas
    },
    {
      path: '/multa/carga/formulario',
      name: 'crearMulta',
      component: CargarMulta
    },
    {
      path: '/multa/carga/excel',
      name: 'crearMultaExcel',
      component: CargarMultaExcel
    },
    {
      path: '/pago-vocales/lista',
      name: 'pago-vocales',
      component: PagoVocales
    },
    {
      path: '/pago-vocales/carga/formulario',
      name: 'crearPago-vocal',
      component: CargaPagoVocal
    },
    {
      path: '/pago-vocales/carga/csv',
      name: 'crearPago-vocalesCSV',
      component: CargaPagoVocales
    },
    {
      path: '/envio-correos',
      name: 'enviar-correos',
      component: envioCorreos
    }

    ]
  },
{
  path: '/unauthorized',
  component: NotAutorizate
},
{
  path: '*',
  component: NotFound
}
]

const route = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  routes
})

export default route;
